<form [formGroup]="keepLogged">
    <mlp-ng-shared-checkbox
        formControlName="keepMeLoggedIn"
        class="d-block"
        size="small"
        >Keep me logged in</mlp-ng-shared-checkbox
    >
</form>
